var _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3225_16763",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 31,
    width: 101,
    height: 95
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6171 31.6599C75.9933 30.9527 77.0067 30.9527 77.3829 31.6599L126.381 123.78C126.735 124.446 126.252 125.25 125.498 125.25H27.5021C26.7476 125.25 26.2649 124.446 26.6192 123.78L75.6171 31.6599Z",
    fill: "#D8B4B4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3225_16763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 64L81.7674 76.2076L92 68.0192L90.0249 80.9751L102.981 79L94.7924 89.2326L107 94L94.7924 98.7674L102.981 109L90.0249 107.025L92 119.981L81.7674 111.792L77 124L72.2326 111.792L62 119.981L63.9751 107.025L51.0192 109L59.2076 98.7674L47 94L59.2076 89.2326L51.0192 79L63.9751 80.9751L62 68.0192L72.2326 76.2076L77 64Z",
    fill: "#FAC53D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 77.9023L79.5581 84.4528L85.0487 80.059L83.9889 87.0109L90.9409 85.9511L86.5471 91.4418L93.0975 93.9999L86.5471 96.558L90.9409 102.049L83.9889 100.989L85.0487 107.941L79.5581 103.547L77 110.097L74.4418 103.547L68.9512 107.941L70.011 100.989L63.0591 102.049L67.4528 96.558L60.9024 93.9999L67.4528 91.4418L63.0591 85.9511L70.011 87.0109L68.9512 80.059L74.4418 84.4528L77 77.9023Z",
    fill: "#FF9F46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 93.9998,
    r: 13.1707,
    fill: "#FF7246"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.618 14.6507C75.9947 13.9457 77.0053 13.9457 77.382 14.6507L140.233 132.279C140.589 132.945 140.106 133.75 139.351 133.75H13.6492C12.894 133.75 12.4113 132.945 12.7672 132.279L75.618 14.6507Z",
    stroke: "#333333",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeat);
export default __webpack_public_path__ + "static/media/heat.6a02043f16521794de5891c12eb969b2.svg";
export { ForwardRef as ReactComponent };